import { app } from '@/index';
import '@/theme/index.less';
app();